import type { HostAdapter } from "../core/types.js";
import { browserHost } from "./browserHost.js";
import { officeHost } from "./officeHost.js";
import { wpsHost } from "./wpsHost.js";

export async function resolveHost(): Promise<HostAdapter> {
  if (typeof Office !== "undefined") {
    await Office.onReady?.();
    if (Office.context?.diagnostics?.host?.toLowerCase().includes("word")) {
      return officeHost;
    }
  }

  if (typeof window !== "undefined" && window.wps) {
    return wpsHost;
  }

  return browserHost;
}
